import { formatNumber } from 'core/service/lib/number-format'

export const dashedOutOrWithPrecision = (value, precision, isRound = true) =>
  value === 0 ? '-' : formatNumber(value, precision, isRound)

const PolicyValueRow = ({
  age,
  yearEndPolicy,
  cumulativeBasicPremium,
  annualBasicPremium,
  surrenderCash,
  annualRiderPremium,
  annualTotalPremium,
  cumulativeDeathBenefit,
  deathBenefit,
  children,
}) => {
  return (
    <tr id={`policy-value-row-${age.value}`}>
      <td className="policy-value-age">{age.value}</td>
      <td className="policy-value-year">{yearEndPolicy}</td>
      <td className="policy-value-annual-basic-premium">{dashedOutOrWithPrecision(annualBasicPremium, 2)}</td>
      <td className="policy-value-annual-rider-premium">{dashedOutOrWithPrecision(annualRiderPremium, 2)}</td>
      <td className="policy-value-annual-total-premium">{dashedOutOrWithPrecision(annualTotalPremium, 2)}</td>
      {children}
      <td className="policy-value-surrender-cash">{dashedOutOrWithPrecision(surrenderCash, 0)}</td>
      <td className="policy-value-death-benefit">{dashedOutOrWithPrecision(deathBenefit, 2)}</td>
    </tr>
  )
}

export default PolicyValueRow
